<div class="flex-container gap-6" style="height: 100%">
  <vl-widget-title
    text="Liste des OFs"
    [widget]="widget()"
    [draggable]="false"
    [editable]="false"
    [filter]="true"
  >
    <ng-content class="drag-handler" select=".drag-handler"></ng-content>

    <!-- Bouton filtre dans le header -->
    <ng-content class="filter" select=".filter">
      <vl-chips
        size="small"
        iconLeft="settings"
        (action)="trigger.attachOverlay()"
        [popoverTrigger]="filters"
        #trigger="popoverElement"
        [closeOnClickOutside]="true"
        state="enabled"
      >
        {{ 'button.filter' | trans }}
      </vl-chips>
    </ng-content>
  </vl-widget-title>

  <!-- Popover des filtres -->
  <ng-template #filters>
    <div class="flex-col w100 gap-8 justup-card p-8 up-3">
      <!-- Top N + recherche -->
      <div class="flex" style="gap:.75rem; align-items:center; flex-wrap:wrap">
        <!--<div class="caption-2 on-background-alt">
          Top {{ topCount() }} / {{ maxRows() }}
        </div>
        <input
          type="range"
          [min]="1"
          [max]="Math.max(1, maxRows())"
          [value]="topCount()"
          (input)="topCount.set(($any($event.target).valueAsNumber)||1)"
          [disabled]="maxRows() <= 1"
          style="width:180px"
          aria-label="Limiter le nombre d’OF affichés"
        />-->
        <div class="search-wrap" style="display:flex;align-items:center;gap:.4rem;">
          <span class="caption-2 on-background-alt">Filtrer :</span>
          <input
            type="search"
            [value]="search()"
            (input)="search.set(($any($event.target).value||'').toString())"
            placeholder="OF n°, article, lot…"
            class="ju-input"
            style="height:28px;padding:0 .5rem; min-width:200px"
            aria-label="Filtrer par OF, article, lot"
          />
        </div>
      </div>

      <!-- Tri + ordre + filtre perf -->
      <vl-chips-toggle [(value)]="sortBy" [elements]="elementsSort"></vl-chips-toggle>
      <vl-chips-toggle [(value)]="sortOrder" [elements]="elementsOrder"></vl-chips-toggle>
      <vl-chips-toggle [(value)]="perfFilter" [elements]="elementsPerf"></vl-chips-toggle>
    </div>
  </ng-template>

  @if (rowsTop().length === 0) {

    <div class="widget-content empty">
      <div class="caption on-disabled">Aucune production trouvée avec ces filtres.</div>
    </div>
  } @else {
    <div class="widget-content fade-in overflow-scroll">
      <div class="table ju-of-table w100" style="overflow-x:auto; ">
        <!-- En-tête -->
        <div class="thead caption-2 on-background-alt">
          <div class="th col-of">{{ 'data.of' | trans }}</div>
          <div class="th col-qty right">Quantité produite</div>
          <div class="th col-cost right">Coût de revient</div>
          <div class="th col-perf right">Performance</div>
        </div>

        <!-- Lignes -->
        @for (r of rowsTop(); track r.of.id) {
          <div class="row table-row border-bottom-outline-opacity-50" (click)="onGoOF(r.of.id)">
            <!-- OF (lot, dates, etc.) -->
            <div class="td col-of on-background">
              <vl-of-card
                [currentOf]="r.of"
                [actions]="true"
                (action)="onGoOF(r.of.id)"
                route="productions/suivi/stats"
              />
            </div>

            <!-- Quantité produite -->
            <div class="td col-qty right on-background text-line">
              <span class="num">{{ r.qte | numberSig }}</span>
              <span class="caption">{{ r.unite }}</span>
            </div>

            <!-- Coût de revient : PU -->
            <div class="td col-cost right on-background">
              <div class="cost-lines">
                <div class="line">
                  <span class="label">PU</span>
                  <span class="value">{{ r.pu | numberSig }} €</span>
                </div>
              </div>
            </div>

            <!-- Performance -->
            <div class="td col-perf on-background">
              <div class="w-content ml-auto">
                @if (r.scoreTotal) {
                  <vl-percent
                    [percent]="r.scoreTotal ?? r.of?.scoreTotal"
                    [typePercent]="TypePercent.OF_TOTAL"
                    [zeroize]="false"
                    [fixed]="0"
                    [simplify]="true"
                    [noPlus]="true"
                  />
                } @else {
                  <div class="caption on-warning right w100">{{ 'data.missing_info' | trans }}</div>
                }
              </div>
            </div>
          </div>
        }

      </div>
    </div>
  }
</div>
